module.exports = __webpack_public_path__ + "static/img/landing_web.5f1768e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/website/landing_web.png
// module id = AvgA
// module chunks = 1